import { ofType } from 'redux-observable';
import {
  catchError,
  delay,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { UPSERT_ONORARIO_INCARICO } from '../../data.const';
import {
  retrieveOnorarioIncaricoListAction,
  setCurrentOnorarioIncaricoAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';
import { rootConfig } from '../../../../../config/root-config';

const upsertOnorarioIncaricoEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(UPSERT_ONORARIO_INCARICO),
    tap(p => console.log(`[epic ${UPSERT_ONORARIO_INCARICO}]`, p)),
    map(({ payload }: any) => {
      const { createdAt, updatedAt, ...rest } = payload?.body;
      if (rest.id === 'crea') {
        delete rest.id;
      }
      return { info: payload?.info, body: rest };
    }),
    tap(p => console.log(`[epic ${UPSERT_ONORARIO_INCARICO}]`, p)),
    withLatestFrom(state$),
    switchMap(([{ body, info }, state]) => {
      return concat(
        of(setLoaders({ incaricoLoader: true, page: true })),
        defer(() =>
          from(
            request({
              path: `onorarioIncarico`,
              method: httpMethods.POST,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error(p.message);
              }
              return p?.result;
            }),
            switchMap(data =>
              concat(
                of(setCurrentOnorarioIncaricoAction(data)),
                of(null).pipe(
                  delay(500),
                  switchMap(() =>
                    concat(
                      of(
                        setPopupInfo({
                          opened: true,
                          message: 'Operazione completata con successo',
                          timer: 3000,
                        })
                      ),
                      of(
                        retrieveOnorarioIncaricoListAction({
                          pageSize: rootConfig.pageSize,
                          page: 1,
                          order: [['descrizione', 'asc']],
                          filters: {
                            or: [
                              {
                                field: '$Incarico.id$',
                                value: info?.incaricoId,
                              },
                            ],
                          },
                        })
                      ),
                      of(null).pipe(
                        tap(() => {
                          info?.action && info?.action();
                        }),
                        switchMap(() => EMPTY)
                      )
                    )
                  )
                )
              )
            ),
            catchError(err => {
              console.error(`[epic ${UPSERT_ONORARIO_INCARICO}] error`, err);
              return of(
                setPopupInfo({
                  opened: true,
                  message: 'Operazione non riuscita',
                  type: 'BAD',
                  timer: 3000,
                })
              );
            })
          )
        ),
        of(setLoaders({ incaricoLoader: false, page: false }))
      );
    })
  );

export default upsertOnorarioIncaricoEpic;
